import * as env from "util/env"

export const genStyles = (theme) =>
  `
    :root {
      --bz-color-1: #${theme["color-1"]};
      --bz-color-2: #${theme["color-2"]};
      --bz-color-3: #${theme["color-3"]};
      --bz-color-4: #${theme["color-4"]};
      --bz-color-5: #${theme["color-5"]};
    }
    .color-1 {color: #${theme["color-1"]};}
    .color-2 {color: #${theme["color-2"]};}
    .color-3 {color: #${theme["color-3"]};}
    .color-4 {color: #${theme["color-4"]};}
    .color-5 {color: #${theme["color-5"]};}
    .background-color-1 {background-color: #${theme["color-1"]} !important;}
    .background-color-2 {background-color: #${theme["color-2"]};}
    .background-color-3 {background-color: #${theme["color-3"]};}
    .background-color-4 {background-color: #${theme["color-4"]};}
    .background-color-5 {background-color: #${theme["color-5"]};}

    .inputs__value___wK0oy,
    .emergency-fund__goal-amount___2ze_j,
    .stimulus__source___2TUyt a {
      color: #${theme["color-1"]};
    }
    .inputs__range___2JfAx input[type=range]::-webkit-slider-thumb {
      border: 1px solid #${theme["color-1"]};
      background: #${theme["color-1"]};
    }
    #title-screen .buttons__round-filled___2jfRx,
    .inputs__range___2JfAx input[type=range]::-webkit-slider-runnable-track {
      background: #${theme["color-1"]};
    }
    #title-screen .buttons__round-filled___2jfRx {
      background: var(--bz-color-primary-1)
    }
    .inputs__range___2JfAx input[type=range]::-moz-range-thumb {
      background-color: #${theme["color-1"]};
      border: none;
    }
    .inputs__range___2JfAx input[type=range]::-moz-range-track {
      background-color: #${theme["color-1"]};
    }
    .inputs__range___2JfAx input[type=range]::-ms-fill-lower {
      background-color: #${theme["color-1"]};
    }
    .inputs__add-entry___3eNud,
    .shared__reset___2QiVT,
    ._bz-reset-arrow_1uy75_337,
    .cost-of-living__result___1QJei {
      color: #${theme["color-1"]};
    }
    .inputs__add-entry___3eNud:hover,
    .stimulus__source___2TUyt a:hover {
      color: #${theme["color-2"]};
    }
    .inputs__small___T_5Pp input[type="text"]:focus,
    .inputs__calc-input-small___39NeD input[type=text]:focus,
    .inputs__calc-input-long___2drYF input[type=text]:focus,
    .inputs__small___T_5Pp input[type="text"]:active,
    .inputs__calc-input-small___39NeD input[type=text]:active,
    .inputs__calc-input-long___2drYF input[type=text]:active {
      border-bottom: 4px solid #${theme["color-1"]};
    }
    .shared__expand___3wpdp {
      color: #${theme["color-1"]} !important;
    }
    .shared__expand___3wpdp:hover {
      color: #${theme["color-2"]} !important;
    }
    .shared__advanced-options___h54Dq svg path {
      fill: #${theme["color-1"]};
    }
    .shared__expand___3wpdp:hover svg path {
      fill: #${theme["color-2"]};
    }
    .shared__button___24Z_e {
      background: #${theme["color-1"]};
      border-color: #${theme["color-1"]};
    }
    .shared__button___24Z_e:hover {
      background: #${theme["color-2"]};
      border-color: #${theme["color-2"]};
    }
    .buttons__ignition___1wCVN {
      background: #${theme["color-1"]};
      border: 2px solid #${theme["color-1"]};
      box-shadow: 0 10px #${theme["color-4"]};
    }
    .buttons__ignition___1wCVN:hover {
      box-shadow: 0 12px #${theme["color-4"]};
      background-color: #${theme["color-1"]};
      border: 2px solid #${theme["color-1"]};
    }
    .buttons__ignition___1wCVN:active {
      background-color: #${theme["color-1"]};
      border: 2px solid #${theme["color-1"]};
      box-shadow: 0 0px #${theme["color-4"]};
    }
    .inputs__radio___2GNDO {
      border: 2px solid #${theme["color-1"]};
      color: #${theme["color-1"]};
    }
    input.inputs__input___3W49J {
      color: #${theme["color-1"]};
    }
    .inputs__input___3W49J:active,
    .inputs__input___3W49J:focus {
      border-bottom: 4px solid #${theme["color-1"]};
    }

    .emergency-fund__selected___3RMx6,
    .emergency-fund__goal___13_PK:hover {
      border-color: #${theme["color-1"]};
    }

    .vacation-affordability__answer___2MlOH {
      color: #${theme["color-1"]};
    }
    .inputs__range___3_x8e input[type=range]::-webkit-slider-thumb {
      border: 1px solid #${theme["color-1"]};
      background: #${theme["color-1"]};
    }
    .inputs__range___3_x8e input[type=range]::-webkit-slider-runnable-track {
      background: #${theme["color-1"]};
    }
    .inputs__range___3_x8e input[type=range]::-moz-range-thumb {
      background-color: #${theme["color-1"]};
      border: none;
    }
    .inputs__range___3_x8e input[type=range]::-moz-range-track {
      background-color: #${theme["color-1"]};
    }
    .inputs__range___3_x8e input[type=range]::-ms-fill-lower {
      background-color: #${theme["color-1"]};
    }
    .inputs__value___3sjZV {
      color: #${theme["color-1"]};
    }
    #heloc-calculator .shared__disclaimer___1vIel {
      margin-left: 4px;
    }
    .inputs__radio___12Yaj,
    .wizard__wizard___1XgXH .inputs__radio___1bC-b,
    .wizard__wizard___1XgXH .inputs__radio___12Yaj {
      border-color: #${theme["color-1"]};
      color: #${theme["color-1"]};
    }
    .inputs__selected-radio___2Qzxa,
    .inputs__selected-radio___2RywZ,
    .inputs__selected-checkbox___2-4Cy,
    .inputs__radio___2GNDO:hover,
    .inputs__radio___12Yaj:hover,
    .wizard__wizard___1XgXH .inputs__radio___1bC-b:hover,
    .wizard__wizard___1XgXH .inputs__radio___12Yaj:hover,
    .wizard__wizard___1XgXH .inputs__selected-radio___2HYgF,
    .wizard__wizard___1XgXH .inputs__selected-radio___2RywZ {
      background: #${theme["color-1"]};
      color: #fff;
    }
    .wizard__wizard___1XgXH input.inputs__input___8qWHm {
      color: #${theme["color-1"]};
    }
    .wizard__wizard___1XgXH .inputs__input___8qWHm:active,
    .wizard__wizard___1XgXH .inputs__input___8qWHm:focus {
      border-color: #${theme["color-1"]};
    }
  `

export const theme = {
  "color-1": env.getMetaContentByName("banzai.theme/color-1") || "006AF9",
  "color-2": env.getMetaContentByName("banzai.theme/color-2") || "4795FF",
  "color-3": env.getMetaContentByName("banzai.theme/color-3") || "00439D",
  "color-4": env.getMetaContentByName("banzai.theme/color-4") || "7BB3FF",
  "color-5": env.getMetaContentByName("banzai.theme/color-5") || "0057CD"
}
